import { render } from "./AlgoliaSearchOne.vue?vue&type=template&id=620f0082"
import script from "./AlgoliaSearchOne.vue?vue&type=script&lang=js"
export * from "./AlgoliaSearchOne.vue?vue&type=script&lang=js"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/QuoteAndBuy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__